<script lang="ts">
  import Landing from './lib/Landing.svelte';
  import TripPage from './lib/TripPage.svelte';
  import Dashboard from './lib/Dashboard.svelte';
  import { TRIP_PATH_REGEX, USER_PATH_REGEX } from '~/shared/token';

  let pathname = $state(window.location.pathname);

  $effect(() => {
    const onPopstate = () => {
      pathname = window.location.pathname;
    };
    window.addEventListener('popstate', onPopstate);
    return () => window.removeEventListener('popstate', onPopstate);
  });

  const tripToken = $derived(TRIP_PATH_REGEX.exec(pathname)?.[1] ?? null);
  const userToken = $derived(USER_PATH_REGEX.exec(pathname)?.[1] ?? null);
</script>

{#if tripToken}
  <TripPage token={tripToken} />
{:else if userToken}
  <Dashboard token={userToken} />
{:else}
  <Landing />
{/if}
